import React from 'react';
import { TabsOrientation, TabsAlignment, TabsBorderPosition } from 'react-magma-dom';
import uuid from 'uuid-random';

import { NavElement } from '../NavElement';
import { StyledNavTabs } from '../Styled';

interface INavigation {
  navLinks: string[];
  tabsAlignment?: TabsAlignment;
  ariaLabel: string;
  current: string;
  isSecondary?: boolean;
  isVertical?: boolean;
  isSideNav?: boolean;
}

export const Navbar: React.FC<INavigation> = (props): JSX.Element => {
  const { navLinks, tabsAlignment, ariaLabel, current, isSecondary, isVertical, isSideNav } = props;

  const renderNavLinks = (links: string[]): JSX.Element[] => {
    return links.map((link: string) => {
      return <NavElement current={current} direction={link.toLocaleLowerCase()} key={uuid()} />;
    });
  };

  return (
    <StyledNavTabs
      isSecondary={isSecondary}
      isSideNav={isSideNav}
      isVertical={isVertical}
      aria-label={ariaLabel}
      orientation={isVertical ? TabsOrientation.vertical : TabsOrientation.horizontal}
      borderPosition={TabsBorderPosition.bottom}
      alignment={tabsAlignment}
    >
      {renderNavLinks(navLinks)}
    </StyledNavTabs>
  );
};
